import { render, staticRenderFns } from "./EntityListGroup.vue?vue&type=template&id=771e1b94&scoped=true&"
import script from "./EntityListGroup.vue?vue&type=script&lang=js&"
export * from "./EntityListGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771e1b94",
  null
  
)

export default component.exports